import * as React from 'react';
import './HighLevelTournamentBreadcrumbs.scss';

interface Crumb {label: string; href?: string; onClick?: () => void;}

export function HighLevelTournamentBreadcrumbs({items}: {items: Crumb[]}) {
  const list = React.useRef<HTMLOListElement>(null);
  const trail = items.map(item => item.label).join(' / ');
  React.useEffect(() => {
    const showCurrent = () => {
      if (window.matchMedia('(max-width: 780px)').matches && list.current) list.current.scrollLeft = list.current.scrollWidth;
    };
    showCurrent();
    window.addEventListener('resize', showCurrent);
    return () => window.removeEventListener('resize', showCurrent);
  }, [trail]);
  return <nav className="hltBreadcrumbs" aria-label="Breadcrumb"><ol ref={list}>
    {items.map((item, index) => {
      const current = index === items.length - 1;
      return <li key={`${index}:${item.label}`}>
        {index > 0 && <svg viewBox="0 0 16 16" aria-hidden="true"><path d="m6 4 4 4-4 4" /></svg>}
        {!current && item.href ? <a href={item.href} title={item.label} onClick={event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !item.onClick) return;
          event.preventDefault(); item.onClick();
        }}>{item.label}</a> : <span title={item.label} aria-current={current ? 'page' : undefined}>{item.label}</span>}
      </li>;
    })}
  </ol></nav>;
}
